module.exports = __webpack_public_path__ + "static/media/eBanner.54002a9c.jpg";